module.exports = __webpack_public_path__ + "img/wechat-qrcode.45293d2e.jpg";